<template>
    <v-form ref="form" @submit.prevent="save">
        <v-card>
            <card-header :title="cardTitle" />
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            v-model="model.slug"
                            :label="$t('resources.settings.attributes.slug')"
                            :error-messages="slugErrors"
                            @input="$v.model.slug.$touch()"
                            @blur="$v.model.slug.$touch()"
                        />
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            v-model="model.name"
                            :label="$t('resources.settings.attributes.name')"
                            :error-messages="nameErrors"
                            @input="$v.model.name.$touch()"
                            @blur="$v.model.name.$touch()"
                        />
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="12">
                        <v-text-field
                            v-model="model.value"
                            :label="$t('resources.settings.attributes.value')"
                            :error-messages="valueErrors"
                            @input="$v.model.value.$touch()"
                            @blur="$v.model.value.$touch()"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <form-actions :loadingSave="loading" />
        </v-card>
    </v-form>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        CardHeader,
        FormActions,
    },

    mixins: [validationMixin],

    props: {
        setting: {
            type: Object,
            required: true,
        },
        titlePrefix: String,
    },

    data() {
        return {
            loading: false,
        }
    },

    validations() {
        return {
            model: {
                slug: { required },
                name: { required },
                value: { required },
            },
        }
    },

    computed: {
        cardTitle() {
            return this.$t('forms.title', {
                prefix: this.titlePrefix,
                resource: this.$tc('resources.settings.name', 1).toLowerCase(),
            })
        },

        slugErrors() {
            const errors = []
            if (!this.$v.model.slug.$dirty) return errors

            !this.$v.model.slug.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.settings.attributes.slug',
                        ).toLowerCase(),
                    }),
                )

            return errors
        },

        nameErrors() {
            const errors = []
            if (!this.$v.model.name.$dirty) return errors

            !this.$v.model.name.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.settings.attributes.name',
                        ).toLowerCase(),
                    }),
                )

            return errors
        },

        valueErrors() {
            const errors = []
            if (!this.$v.model.value.$dirty) return errors

            !this.$v.model.value.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.settings.attributes.value',
                        ).toLowerCase(),
                    }),
                )

            return errors
        },

        model() {
            return this.setting
        },
    },

    methods: {
        async save() {
            this.loading = true

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.loading = false
                return
            }

            let res = await this.model.save()
            this.loading = false
            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('forms.messages.saved', {
                    resource: this.$tc(
                        'resources.settings.name',
                        1,
                    ).toLowerCase(),
                    name: this.model.name,
                }),
            )

            this.$emit('saved')
        },
    },
}
</script>

<style></style>
